import { Component, OnInit } from '@angular/core';
import { ContactsGroupsList } from '../../models/notification.model';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-contacts-groups',
  templateUrl: './contacts-groups.component.html',
  styleUrls: ['./contacts-groups.component.scss']
})
export class ContactsGroupsComponent implements OnInit {

  displayedColumns=[
    'number',
    'name',
    'action',
  ]

  pageSizeOptions:number[] = [
    20,
    50,
    100,
    200,
    500
  ];
  pageSize:number = this.pageSizeOptions[0];
  pageOffset: number = 0;
  pageIndex: number = 0;

  contactsGroupsList:ContactsGroupsList

  constructor(
    private notificationService : NotificationService
  ) { }

  ngOnInit(): void {
    this.getNotificationContactsGroupsList()
  }

  getNotificationContactsGroupsList(reset:boolean=false){
    if(reset) {
      this.pageOffset = 0;
      this.pageIndex = 0;
    }
    let filters = { limit: this.pageSize, offset: this.pageOffset , ordering:'-id'};
    this.notificationService.getNotificationContactsGroupsList(filters).subscribe(res=>{
      this.contactsGroupsList=res;
    })
  }

  onPaginationChange(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.pageOffset = this.pageIndex * this.pageSize;
    this.getNotificationContactsGroupsList()
  }

}
